/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CourseStatus = "complete" | "failed" | "incomplete" | "%future added value";
export type CourseTable_delegate = {
    readonly myCourses: ReadonlyArray<{
        readonly status: CourseStatus;
        readonly expiresAt: string | null;
        readonly enrolledAt: string;
        readonly certificateURL: string | null;
        readonly progress: {
            readonly total: number;
            readonly completed: number;
        } | null;
        readonly partTwo: {
            readonly status: CourseStatus;
            readonly certificateURL: string | null;
            readonly expiresAt: string | null;
        } | null;
        readonly course: {
            readonly name: string;
            readonly category: {
                readonly name: string;
            } | null;
            readonly partTwo?: {
                readonly ident: number;
            } | null;
        } | null;
    }> | null;
    readonly myClassroomCourses: ReadonlyArray<{
        readonly status: CourseStatus;
        readonly expiresAt: string | null;
        readonly enrolledAt: string;
        readonly certificateURL: string | null;
        readonly course: {
            readonly ident: number;
            readonly name: string;
            readonly category: {
                readonly name: string;
            } | null;
        } | null;
    }> | null;
    readonly " $refType": "CourseTable_delegate";
};
export type CourseTable_delegate$data = CourseTable_delegate;
export type CourseTable_delegate$key = {
    readonly " $data"?: CourseTable_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"CourseTable_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expiresAt",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrolledAt",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "certificateURL",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": [
            (v4 /*: any*/)
        ]
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "CourseTable_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "myCourses",
                "storageKey": null,
                "args": null,
                "concreteType": "MyCourse",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "progress",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Progress",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "total",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "completed",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "partTwo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MyCourse",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v3 /*: any*/),
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "course",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                            (v4 /*: any*/),
                            (v5 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "type": "OnlineCourse",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "partTwo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": null,
                                        "plural": false,
                                        "selections": [
                                            (v6 /*: any*/)
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "myClassroomCourses",
                "storageKey": null,
                "args": null,
                "concreteType": "MyCourse",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "course",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                            (v6 /*: any*/),
                            (v4 /*: any*/),
                            (v5 /*: any*/)
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'aebbbc4e7b8e2f40876d67def0efa625';
export default node;
